type InitialState = {
  customerNumber: string;
};

const initialState: InitialState = {
  customerNumber: '',
};

const getters = {
  getCustomerNumber(state) {
    return state.customerNumber;
  },
};

const mutations = {
  setCustomerNumber(state, customerNumber) {
    state.customerNumber = customerNumber;
  },
};

export default {
  state: () => ({ ...initialState }),
  getters,
  mutations,
};
